import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './app/App';

import { AuthProvider } from './context/AuthContext';
import { ChatProvider } from './context/ChatContext';
import GroupProvider from './context/GroupAdminContext';

import { HelmetProvider } from '@dr.pogodin/react-helmet';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>

      <BrowserRouter>
        <AuthProvider>
          <ChatProvider>
            <GroupProvider>
              <App />
            </GroupProvider>
          </ChatProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);